// src/context/ProgramContext.js
import React, { createContext, useState, useContext } from 'react';

// Define the shape of the context data
// selectedProgram will hold the full program object fetched from the API
// setSelectedProgram will be the function to update it
const ProgramContext = createContext({
  selectedProgram: null,
  setSelectedProgram: () => {}, // Default empty function
});

// Create a Provider component
export const ProgramProvider = ({ children }) => {
  const [selectedProgram, setSelectedProgram] = useState(null);

  // The value prop of the Provider shares the state and the updater function
  const value = { selectedProgram, setSelectedProgram };

  return (
    <ProgramContext.Provider value={value}>
      {children}
    </ProgramContext.Provider>
  );
};

// Create a custom hook for easy consumption of the context
// This avoids needing to import useContext and ProgramContext in every consumer component
export const useProgram = () => {
  const context = useContext(ProgramContext);
  if (context === undefined) {
    throw new Error('useProgram must be used within a ProgramProvider');
  }
  return context;
};

// Export the context itself if needed elsewhere (less common)
export default ProgramContext;